import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { MORE_DOTS_ICON, MORE_WHITE_DOTS_ICON } from '../config/constant/assetConstant';

export default function MenuDropdown(props) {
  const {
    isWhite = false,
    menu = [],
    list: data,
    handleSelect = () => {},
    openButton = null,
    icon = null,
    defaultPrevent = null,
  } = props || {};
  if (menu?.length === 0) return null;
  return (
    <Dropdown
      className={`custom-dropdown ${props?.className || ''}`}
      align="end"
      onClick={(e) => {
        if (!defaultPrevent) {
          e.stopPropagation();
          e.preventDefault();
        }
      }}>
      <Dropdown.Toggle className={`${isWhite ? 'bg-transparent' : props?.btnClassName || ''}`}>
        {openButton ? (
          openButton
        ) : icon ? (
          icon
        ) : (
          <img src={isWhite ? MORE_WHITE_DOTS_ICON : MORE_DOTS_ICON} alt="more" />
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {menu?.map((a, index) => {
          return (
            <Dropdown.Item
              className="justify-content-start"
              key={index}
              value={a?.value}
              disabled={a?.disabled ?? false}
              onClick={() => (handleSelect ? handleSelect(a, data) : a?.onClick?.())}>
              {a?.icon && !a?.afterIcon && <span className="me-2">{a?.icon}</span>}
              {a?.label}
              {a?.icon && a?.afterIcon && <span className="me-2">{a?.icon}</span>}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
}
